<div class="px-4 py-3">
    <!-- Notification settings -->
    <form [formGroup]="settingsFormGroup">
        <fieldset class="border border-dark p-2 fieldset">
            <div class="loading-indicator">
                @if (isLoading) {
                    <mat-spinner [diameter]="32" />
                }
                @if (!isLoading && isInvalid) {
                    <mat-icon class="error">highlight_off</mat-icon>
                }
                @if (!isLoading && !isInvalid) {
                    <mat-icon>check</mat-icon>
                }
            </div>
            <legend class="fieldset-legend w-auto px-2">
                <mat-checkbox [formControl]="settingsFormGroup.controls.emailNotificationsEnabled">
                    {{ 'NotificationSettings.EmailNotificationsEnabled' | translate }}
                </mat-checkbox>
            </legend>
            <mat-checkbox [formControl]="settingsFormGroup.controls.useSchedule">
                {{ 'NotificationSettings.EmailSchedule' | translate }}
            </mat-checkbox>
            <sl-cron-input [formControl]="settingsFormGroup.controls.emailSchedule" />
        </fieldset>
    </form>

    <!-- Alerts -->
    <sl-alerts class="d-block mt-5" />
</div>
